<template>
  <div class="full-indicators-info">
    <v-container>
      <v-row class="d-flex flex-row align-center justify-space-between">
          <v-btn
              class="blue__v-btn"
              :loading="downloadNow"
              :disabled="!blocked"
              @click="downloadPrint('KcpAddPdf', 'downloadingPrint2','Отчёт KcpAdd.pdf','application/pdf', `?orgId=${userId}`)"
          >
            Формы для самопроверки
          </v-btn>
          <v-btn
              class="success__v-btn"
              :loading="loadingBlockInfo"
              :disabled="(blocked || hasConfirmFile) && !isAdmin"
              @click="setBlockInfo"
          >
            {{ blocked ? 'Разблокировать' : 'Заблокировать' }}
          </v-btn>
      </v-row>
      <v-row v-if="blocked && isValidSystemSetup && !hasConfirmFile" class="pt-2 d-flex flex-row justify-space-between">
          <v-autocomplete
              v-model="chosenCertificate"
              :items="certificatesList"
              label="Выберите сертификат, которым будет произведена подпись данных"
              no-data-text="Нет доступных сертификатов"
              dense
              class="mt-2 mr-2"
              clearable
              outlined
          ></v-autocomplete>
          <v-btn class="mt-2 blue__v-btn" :disabled="hasConfirmFile" :loading="signingFile"
                 @click="signFile('KcpAddPdf', 'downloadingPrint', 'CONFIRMED_FILE_KCP_ADD', null, `?orgId=${userId}`)">
            Подписать
          </v-btn>
      </v-row>
      <v-row v-if="blocked && !isValidSystemSetup">
              <span class="red--text">Не установлен CryptoPro CAdES или плагин работает не правильно.
                Проверить проблемы можно на странице <a
                    href="https://cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html">Проверка создания электронной подписи CAdES-BES</a></span>
      </v-row>
    </v-container>
    <alert v-if="blocked && !loading">
      <file-container
        ref="vbn"
        :current-stage="currentStage"
        :files-config="filesConfig"
      />
    </alert>
    <table class="full-indicators-info__table">
      <thead>
      <tr>
        <th>Образовательная организация. УГСН (НПС)</th>
        <th>Очная форма</th>
        <th>Очно-заочная форма</th>
        <th>Заочная форма</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="!loading">
        <tr v-for="(item) in serverData" :key="calcIdRow(item)">
          <td v-if="item.orgFlag" class="full-indicators-info__table-org" colspan="4">{{ item.orgName }}</td>
          <td v-else-if="item.uslName" class="full-indicators-info__table-usl" colspan="4">{{ item.uslName }}</td>
          <template v-else>
            <td>
              <span class="kcp-code">{{ item.kcpGroup.code }}</span>
              <span class="kcp-name">{{ item.kcpGroup.name }}</span>
            </td>
            <!--            @click="openScore(item.id, 1, 1, item.qkcpo24Add, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"-->
            <td
              class="kcp-percent-scale__stage-one"
              :class="{'kcp-percent-scale__disabled': item.qkcpo24Add == null}"
            >
              <div style="position: relative; display: flex; flex-direction: row; justify-content: space-evenly">
                <div
                  class="d-flex align-center justify-start mr-5"
                  :class="{'': item.qkcpo24Accept != null && item.qkcpo24Add, 'justify-center': !item.qkcpo24Add}"
                >
                  {{ showingValue(item, 'qkcpo24Add') }}
                </div>
                <div class="tooltip-indicators-decline">
                  <indicators-field-correct
                    v-if="item.qkcpo24Add"
                    :value="item.qkcpo24Accept"
                    data-field="qkcpo24Accept"
                    :row="item"
                    :disabled="blocked"
                    :max-value="item.qkcpo24Add"
                    :loading="editing"
                    @change-value-dop="changeValue($event)"
                  />
                </div>
              </div>
            </td>
            <!--            @click="openScore(item.id, 1, 2, item.qkcpv24Add, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"-->
            <td
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpv24Add == null}"
            >
              <div style="position: relative; display: flex; flex-direction: row; justify-content: space-evenly">
                <div
                  class="d-flex align-center justify-start mr-5"
                  :class="{'': item.qkcpv24Accept != null && item.qkcpv24Add, 'justify-center': !item.qkcpv24Add}"
                >
                  {{ showingValue(item, 'qkcpv24Add') }}
                </div>
                <div class="tooltip-indicators-decline">
                  <indicators-field-correct
                    v-if="item.qkcpv24Add"
                    :value="item.qkcpv24Accept"
                    data-field="qkcpv24Accept"
                    :row="item"
                    :disabled="blocked"
                    :max-value="item.qkcpv24Add"
                    :loading="editing"
                    @change-value-dop="changeValue($event)"
                  />
                </div>
              </div>
            </td>
            <!--            @click="openScore(item.id, 1, 3, item.qkcpz24Add, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"-->
            <td
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpz24Add == null}"
            >
              <div style="position: relative; display: flex; flex-direction: row; justify-content: space-evenly">
                <div
                  class="d-flex align-center justify-start mr-5"
                  :class="{'': item.qkcpz24Accept != null && item.qkcpz24Add, 'justify-center': !item.qkcpz24Add}"
                >
                  {{ showingValue(item, 'qkcpz24Add') }}
                </div>
                <div class="tooltip-indicators-decline">
                  <indicators-field-correct
                    v-if="item.qkcpz24Add"
                    :value="item.qkcpz24Accept"
                    data-field="qkcpz24Accept"
                    :max-value="item.qkcpz24Add"
                    :row="item"
                    :disabled="blocked"
                    :loading="editing"
                    @change-value-dop="changeValue($event)"
                  />
                </div>
              </div>
            </td>
          </template>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td class="full-indicators-info__table-org" rowspan="4" colspan="4">
            <v-progress-linear indeterminate></v-progress-linear>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <!--    <confirm-dialog ref="agree-dialog" text="Вы уверены?"/>-->
  </div>
</template>

<script>
import {calcBackground} from "@/utils/indicators";
import {
  getAllGroupedKcpIndicatorsStage1CorrectValues,
  getBlockCorrectIndicatorInfo,
  putCorrectValueAppeal, setBlockCorrectIndicatorInfo
} from "@/api/indicators";
import IndicatorsFieldCorrect from "@/components/fields/indicatorsFieldCorrect";
import Alert from "@/components/cards/Alert";
import {setFileFunctions} from "@/mixins/fileFucntions";
import {mapGetters} from "vuex";
import FileContainer from "@/containers/FileContainer";
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";

export default {
  name: "allListStage1CorrectValues",
  components: {FileContainer, Alert, IndicatorsFieldCorrect},
  mixins: [setFileFunctions, setCryptoProFunctions],
  data() {
    return {
      serverData: [],
      loading: false,
      loadingBlockInfo: false,
      block: null,
      editing: false,
      downloadNow: false,
      filesConfig: [
        {
          name: 'Файл KcpAddPdf',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'CONFIRMED_FILE_KCP_ADD'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('keycloak', {isAdmin: 'isAdmin'}),
    ...mapGetters('checkFilled', {currentStage: 'currentStage', getFilesList: 'getFilesList'}),
    blocked() {
      return !!this.block?.isBlocked
    },
    hasConfirmFile() {
      const cffile = this.getFilesList.filter(item => item.fileType === 'CONFIRMED_FILE_KCP_ADD')[0];
      return cffile !== undefined && cffile !== null && !!cffile.id;
    }
  },
  created() {
    this.getServerData();
    this.getBlockInfo();
  },
  watch: {
    blocked(newval) {
      if (newval)
        this.checkSystem();
    }
  },
  methods: {
    initFiles() {
      this.$refs.vbn.initFiles()
    },
    async getServerData() {
      try {
        this.loading = true;
        // await this.$refs.vbn.initFiles()
        this.serverData = await getAllGroupedKcpIndicatorsStage1CorrectValues();
        this.loading = false;
      } catch (e) {
        console.error(e)
        this.loading = false;
      }
    },
    async getBlockInfo() {
      try {
        this.loadingBlockInfo = true;
        this.block = await getBlockCorrectIndicatorInfo();
        this.loadingBlockInfo = false;
      } catch (e) {
        console.error(e)
        this.loadingBlockInfo = false;
      }
    },
    async setBlockInfo() {
      try {
        this.loadingBlockInfo = true;
        const payload = this.block;
        payload.isBlocked = !payload.isBlocked;
        this.block = await setBlockCorrectIndicatorInfo(payload);
        this.loadingBlockInfo = false;
      } catch (e) {
        console.error(e)
        this.loadingBlockInfo = false;
      }
    },
    // eslint-disable-next-line no-unused-vars
    async changeValue(e) {
      try {
        this.editing = true;
        const index = this.serverData.findIndex(el => el.id === e.id);
        const obj = this.serverData[index];
        obj[e.dataField] = e.value;
        const res = await putCorrectValueAppeal(obj);
        this.serverData.splice(index, 1, res);
        this.editing = false;
      } catch (e) {
        this.editing = false;
        console.error(e)
      }
    },
    calcBackground(value, maxValue, minValue = 0) {
      return calcBackground(value, maxValue, minValue)
    },
    // eslint-disable-next-line no-unused-vars
    openScore(rowId, s0b, appForm, score, usl, kcp, org) {
      // const {id, code, name} = kcp;
      // if (score != null)
      //   this.$router.push({path: '/indicators/details', query: {fo: appForm, id: rowId,kcpId : id, code: code, name: name, value: score, usl: usl, org: org}})
    },
    showingValue(item, dataField) {
      return item[dataField] == null ? 'нет заявки' : item[dataField]/*.toFixed(3)*/
    },
    calcIdRow(item) {
      return item.kcpGroup?.id ? Math.random() + '-' + (item.kcpGroup.id + '-' + item.kcpGroup.usl.id + '-' + item.orgId) : (Math.random() + '-' + item.orgId)
    }
  },
}
</script>

<style lang="sass">
.tooltip-indicators-decline
  display: block
  //position: absolute
  right: 0
  top: 0

.input-text-center-dop
  input
    font-size: 14px
    color: #455A64 !important
    text-align: center

    &::placeholder
      font-size: 12px
      color: #455A64
</style>